"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var NestedDropdownHeader = function NestedDropdownHeader(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "dropdown-selector__header"
  }, children);
};

var _default = NestedDropdownHeader;
exports.default = _default;